import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskEditComponent } from '@fi-shared/fi-task-shared/task-edit/task-edit.component';
import { FormsModule } from '@angular/forms';
import { FiValidatingFormModule } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.module';
import { TaskEditTaskComponent } from './task-edit-task/task-edit-task.component';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiObjectsSelectorComponentModule } from '@fi-shared/objects-selector';
import { FiDatePickerModule } from '@fi-shared/fi-date-picker';
import { MatButtonModule } from '@angular/material/button';
import { FiInsertMediaModule } from '@fi-shared/fi-insert-media/fi-insert-media.module';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { TaskEditTaskNameComponent } from './task-edit-task/task-edit-task-name/task-edit-task-name.component';
import { FiContenteditableModule } from '@fi-shared/fi-contenteditable/fi-contenteditable.module';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';
import { TaskEditTaskNameInputComponent } from './task-edit-task/task-edit-task-name/task-edit-task-name-input/task-edit-task-name-input.component';
import { MatRadioModule } from '@angular/material/radio';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { TaskEditTaskDeadlineComponent } from './task-edit-task/task-edit-task-deadline/task-edit-task-deadline.component';
import { TaskEditTaskAssigneeModule } from '../task-edit-task-assignee/task-edit-task-assignee.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        FiValidatingFormModule,
        FiErrorMessageModule,
        FiAppTextSharedModule,
        FiObjectsSelectorComponentModule,
        FiDatePickerModule,
        FiInsertMediaModule,
        FiAttachmentsModule,
        FiFormatDateModule,
        FiContenteditableModule,
        SelectSearchModule,
        MatRadioModule,
        FiProfileIconModule,
        TaskEditTaskAssigneeModule,
    ],
    declarations: [
        TaskEditComponent,
        TaskEditTaskComponent,
        TaskEditTaskNameComponent,
        TaskEditTaskNameInputComponent,
        TaskEditTaskDeadlineComponent,
    ],
    exports: [TaskEditComponent, TaskEditTaskDeadlineComponent],
})
export class TaskEditModule {}
